import React from 'react';
import { components, SingleValueProps } from 'react-select';
import BaseSelectWithIcon from 'lib/BaseSelect/BaseSelectWithIcon';
import barChartSvg from 'assets/icons/graph-bar-chart.svg';
import { metricOptions, metricTypeToName } from 'components/common/DrilldownReports/consts';
import { MetricType } from 'components/common/types/DrilldownReports.types';

interface FilterMetricsProps {
  selectedMetricType: MetricType;
  changeFilters: (metricType: MetricType) => void;
  isDisabled?: boolean;
}

const CustomSingleValue = ({
  clearValue,
  cx,
  getStyles,
  getValue,
  hasValue,
  isMulti,
  isRtl,
  options,
  selectOption,
  selectProps,
  setValue,
  theme,
  data,
  innerProps,
  isDisabled: singleValueDisabled,
  children,
}: SingleValueProps): React.ReactElement => {
  return (
    <components.SingleValue
      clearValue={clearValue}
      cx={cx}
      getStyles={getStyles}
      getValue={getValue}
      hasValue={hasValue}
      isMulti={isMulti}
      isRtl={isRtl}
      options={options}
      selectOption={selectOption}
      selectProps={selectProps}
      setValue={setValue}
      theme={theme}
      data={data}
      innerProps={innerProps}
      isDisabled={singleValueDisabled}
    >
      <div className="truncate max-w-full">{children}</div>
    </components.SingleValue>
  );
};

const FilterMetrics: React.FC<FilterMetricsProps> = ({ selectedMetricType, changeFilters, isDisabled = false }) => {
  return (
    <div className="w-44">
      <BaseSelectWithIcon
        dataTestId="metrics-select"
        name="metrics"
        classNameWrapper="w-full"
        icon={barChartSvg}
        selectedValue={{ name: metricTypeToName[selectedMetricType], code: selectedMetricType }}
        onSelect={(_, metric: { code: MetricType; name: string }) => {
          const selectedMetric = Array.isArray(metric) ? metric[0] : metric;
          if (selectedMetric) {
            changeFilters(selectedMetric.code);
          }
        }}
        placeholder="Select metrics"
        options={metricOptions}
        isDisabled={isDisabled}
        customComponents={{
          SingleValue: CustomSingleValue,
        }}
      />
    </div>
  );
};

export default FilterMetrics;
